import Vue from 'vue';
import events from './events';
// import miniToastr from 'mini-toastr';
import router from '../../router/index.js';
// import version from "@/version.json";
import { each } from 'lodash';

const dp = require('@/store/plugins/dash_pb');
const dash = dp.dash;

export default {
  state: {
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
    editor: {
      queues: {},
      paused: {},
      content: {},
    },
  },
  mutations:{
    SOCKET_CONNECT: () => {
      Vue.prototype.$connect();
    },
    SOCKET_DISCONNECT: () => {
      Vue.prototype.$disconnect();
    },
    SOCKET_ONOPEN: (state, event) => {
      Vue.prototype.$socket = event.currentTarget;
      state.socket.isConnected = true;
    },
    SOCKET_ONCLOSE: (state) => {
      state.socket.isConnected = false;
    },
    SOCKET_ONERROR: (state) => {
      console.error(state);
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE: (state, event) => {
      event.data.arrayBuffer().then(function (buf) {
        let am = dash.AppMessage.deserializeBinary(buf);
        const typ = am.getMessagetype();
        //console.log({am, typ})
        switch (typ) {
          case 3:
              {
              const qin = am.getQueues().toObject();
              let qs = {};
              each(qin.queuesMap, v => {
                qs[v[0]] = v[1].valueList;
                state.editor.queues = qs;
              });
              let ps = {};
              each(qin.pausedMap, v => {
                ps[v[0]] = v[1];
                state.editor.paused = ps;
              });
            }
            break;
          case 4:
            state.editor.content = am.getQueuecontent().toObject().payload
            break;
          case 6:
            try {
              if(am && am.getResponse() && am.getResponse().getData()) {
                let responseData = am.getResponse().getData().toObject()?.value;
                if(responseData !== null && events.state.eventsData) {
                  responseData = JSON.parse(atob(responseData));
                  responseData.forEach(row => {
                    row.eventdate = parseInt(row.eventdate) * 1000;
                  })
                  const pageSize = events.state.eventsData.length;
                  events.state.eventsData.unshift(...responseData);
                  events.state.eventsData = events.state.eventsData.splice(0, pageSize);
                }
                return
              }
            } catch(e) {
              // Vue.prototype.$disconnect();
            }
        //   case 16:
        //     try {
        //       const remoteVersion = am.array[17][0]
        //       if(remoteVersion) {
        //         if(remoteVersion !== version.rev) {
        //           miniToastr.success('A new version of Apio is available. Please refresh your browser to get it', '');
        //         }
        //       }
        //     } catch(e) {
        //       // Vue.prototype.$disconnect();
        //     }
          }
      });
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT: (state) => {
      state.socket.reconnectError = false;
      // console.info(state, count);
    },
    SOCKET_RECONNECT_ERROR: (state) => {
      if (router.currentRoute.path != '/pages/login') {
        router.push({ path: '/pages/login', query: { redirect: location.href } });
      }
      state.socket.reconnectError = true;
    },
  },
  getters: {
    isConnected: (state) => {
      return state.socket.isConnected;
    },
  },
  actions: {
    sendMessage: async (context, message) => {
      Vue.prototype.$socket.send(message);
    },
    pauseQueue: async (context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEPAUSEQUEUE);
      let dc = new dash.PauseQueueCommand();
      dc.setInterface(payload.intfName);
      dc.setQueue(payload.intfName + '∫' + payload.qinfo.shortname);
      dc.setAppid(payload.appid);
      c.setPausequeue(dc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    resumeQueue: async (context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPERESUMEQUEUE);
      let dc = new dash.ResumeQueueCommand();
      dc.setInterface(payload.intfName);
      dc.setQueue(payload.intfName + '∫' + payload.qinfo.shortname);
      dc.setAppid(payload.appid);
      c.setResumequeue(dc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    getContent: async (context,payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEQUEUEITEM);
      let dc = new dash.QueueItemCommand();
      dc.setQueue(payload.intfName + '∫' + payload.qinfo.shortname);
      dc.setAppid(payload.appid);
      dc.setId(payload.qinfo.qid);
      c.setQueueitem(dc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    setContent: async (context,payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEREPLACEQUEUEPAYLOAD);
      let dc = new dash.ReplaceQueuePayloadCommand();
      dc.setInterface(payload.intfName);
      dc.setQueue(payload.qinfo.shortname);
      dc.setAppid(payload.appid);
      // dc.setItemid(payload.qinfo.qid);
      // dc.setPayload(payload.payload);
      c.setReplacequeuepayload(dc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    debugOn: async (context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEDEBUG);
      let dc = new dash.DebugCommand();
      dc.setInterface(payload.intfName);
      dc.setAppid(payload.appid);
      c.setDebug(dc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    updateApp: async (context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPESETCONFIG);
      let scc = new dash.SetConfigCommand();
      scc.setInterfaceid(payload.interfaceID);
      scc.setAppid(payload.appID);
      c.setSetconfig(scc);
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    debugOff: async (context, appid) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPESTOP);
      let dc = new dash.StopCommand();
      dc.setAppid(appid);
      c.setStop(dc);
      if(Vue.prototype.$socket) {
        Vue.prototype.$socket.send(c.serializeBinary());
      }
    },
    delFromQueue: async (context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEDELETE);
      let dc = new dash.DeleteCommand();
      dc.setInterface(payload.interfaceID);
      dc.setQueue(payload.queue);
      dc.setAppid(payload.appID);
      dc.setKey(payload.key);
      c.setDelete(dc);
      if(!Vue.prototype.$socket) {
        return;
      }
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    startDataStream: async(context, payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPESTARTDATASTREAM);
      let dc = new dash.StartDataStreamCommand();
      dc.setAppid(payload.appHash);
      dc.setInterface(payload.interfaceHash);
      dc.setClient(payload.client);
      // dc.setId(payload.id);
      c.setStartdata(dc);
      if(!Vue.prototype.$socket) {
        return;
      }
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    stopDataStream: async(context,payload) => {
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPESTOPDATASTREAM);
      let dc = new dash.StopDataStreamCommand();
      dc.setAppid(payload.appID);
      dc.setInterface(payload.interfaceID);
      dc.setClient(payload.client);
      c.setStopdata(dc);
      if(!Vue.prototype.$socket) {
        return;
      }
      Vue.prototype.$socket.send(c.serializeBinary());
    },
    playDebug: async(context,payload) => {
      /*     string AppID = 1;
    string Hash = 2;
    string Interface = 3;
    bool Pinned = 4;

      msg.setAppid(value);
      msg.setHash(value);
      msg.setInterface(value);
      msg.setPinned(value);
      break; */
      let c = new dash.CommandMessage();
      c.setCommandtype(dash.CommandType.TYPEPLAYCOMMAND);
      let dc = new dash.PlayCommand();
      dc.setAppid(payload.appID);
      dc.setInterface(payload.interfaceID);
      dc.setPinned(payload.pinned);
      c.setPlay(dc);
      if(!Vue.prototype.$socket) {
        return;
      }
      Vue.prototype.$socket.send(c.serializeBinary());
    }
  },
}
